export class ConceptSymptom{
  name = null;
  code = null;
  description = null;
  service = [];
}
